import api from '../services/api';
import { querystring } from '../utils/resposta';

// Relatórios do painel (somente administrador, somente leitura).
const get = (caminho, filtros) =>
  api.get(`/relatorios/${caminho}${querystring(filtros)}`)
    .then(response => response)
    .catch(error => error);

const Relatorio = {
  resumo: () => get('resumo'),
  // Usuários novos, plantios e mudas por mês (sempre todos os meses do período).
  crescimento: (filtros) => get('crescimento', filtros),
  // Últimos usuários, plantios e pedidos de perfil.
  recentes: (filtros) => get('recentes', filtros),
  plantiosPorLocalidade: (filtros) => get('plantios/localidade', filtros),
  usuariosPorLocalidade: (filtros) => get('usuarios/localidade', filtros),
  especies: (filtros) => get('especies', filtros),
};

export default Relatorio;
